(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  
  
  
  
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }
  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mj-best-sellers"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mj-carousel')) {
    customElements.define('mj-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.mj-carousel__track');
        this.btns = this.querySelectorAll('.mj-carousel__btn');
        if (!this.track) return;
        const rtl = getComputedStyle(this).direction === 'rtl';
        const smooth = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        this.btns.forEach((b) => b.addEventListener('click', () => {
          const item = this.track.firstElementChild;
          const step = item ? item.getBoundingClientRect().width + 20 : this.track.clientWidth;
          const dir = Number(b.dataset.dir) * (rtl ? -1 : 1);
          this.track.scrollBy({ left: dir * step, behavior: smooth });
        }));
        this.update = () => {
          const max = this.track.scrollWidth - this.track.clientWidth - 2;
          const pos = Math.abs(this.track.scrollLeft);
          this.btns.forEach((b) => {
            const back = (Number(b.dataset.dir) < 0);
            b.disabled = back ? pos <= 2 : pos >= max;
          });
        };
        this.track.addEventListener('scroll', this.update, { passive: true });
        window.addEventListener('resize', this.update);
        this.update();
      }
      disconnectedCallback() { window.removeEventListener('resize', this.update); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mj-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mj-carousel')) {
    customElements.define('mj-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.mj-carousel__track');
        this.btns = this.querySelectorAll('.mj-carousel__btn');
        if (!this.track) return;
        const rtl = getComputedStyle(this).direction === 'rtl';
        const smooth = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        this.btns.forEach((b) => b.addEventListener('click', () => {
          const item = this.track.firstElementChild;
          const step = item ? item.getBoundingClientRect().width + 20 : this.track.clientWidth;
          const dir = Number(b.dataset.dir) * (rtl ? -1 : 1);
          this.track.scrollBy({ left: dir * step, behavior: smooth });
        }));
        this.update = () => {
          const max = this.track.scrollWidth - this.track.clientWidth - 2;
          const pos = Math.abs(this.track.scrollLeft);
          this.btns.forEach((b) => {
            const back = (Number(b.dataset.dir) < 0);
            b.disabled = back ? pos <= 2 : pos >= max;
          });
        };
        this.track.addEventListener('scroll', this.update, { passive: true });
        window.addEventListener('resize', this.update);
        this.update();
      }
      disconnectedCallback() { window.removeEventListener('resize', this.update); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;

            const recommendations = html.querySelector('[grid-recommendation]');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.querySelector('[grid-recommendation]').innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
